import { Icon as IconDeals } from '@pwc/pwc-deals-ui';
import { FC } from 'react';

type Props = {
  href: string;
};

export const ProjectLinkWithIcon: FC<Props> = ({ href, children }) => (
  <>
    <a
      href={href}
      className="external-source-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>{' '}
    <IconDeals
      name="box-arrow-up-right"
      className="fill icon-orange"
      width="16"
    />
  </>
);
